import React from "react";
import PropTypes from "prop-types";
import * as classes from "./CardSection.module.css";

const CardSection = ({ children }) => {
  return <section className={classes.grid}>{children}</section>;
};

CardSection.propTypes = {
  children: PropTypes.array.isRequired
};

export default CardSection;
